import { Component } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TakePhotoComponent } from './takePhoto/takePhoto.component';
@Component({
    selector: 'page-perfil',
    templateUrl: './perfil.component.html',
    styleUrls: ['./perfil.component.css'],
    providers: [UserService]
})

export class PerfilComponent {
    identity;
    token;
    edit:Boolean = false;

    constructor(public _userService: UserService, private bottomSheet: MatBottomSheet){
        this.identity = sessionStorage.getItem("identity-domCloud")
    }

    ngDoCheck(){
    
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
      }

    updateProfile(){

    }
    updatePhoto(){
        this.bottomSheet.open(TakePhotoComponent)
    }
}